import { FiMail } from "react-icons/fi";
import { links } from "../data/profile";
import "../styles/Writing.css";

const topics = [
  "OpenTelemetry migration patterns",
  "Alerting that engineers do not mute",
  "SLOs for legacy estates",
  "AIOps beyond the buzzword",
];

const Writing = () => (
  <div className="page">
    <header className="page-head animate-in">
      <h1 className="page-head__title">
        <span className="gradient-text">Writing</span>
      </h1>
      <p className="lede">
        Notes on observability, SRE practice, and the gap between a dashboard
        and an answer. First posts are in progress.
      </p>
    </header>

    <section className="section">
      <div className="glass-card soon animate-in stagger-1">
        <span className="soon__badge">
          <span className="soon__pulse" aria-hidden="true" />
          Coming soon
        </span>
        <h2 className="soon__title">On the list</h2>
        <ul className="soon__list">
          {topics.map((topic) => (
            <li key={topic}>{topic}</li>
          ))}
        </ul>
        <a className="btn" href={links.email}>
          Suggest a topic <FiMail />
        </a>
      </div>
    </section>
  </div>
);

export default Writing;
